import Axios from "axios";
import { SETTINGS } from "../../../properties/ApiProps";

export const GradingSchemaRepository = {
  fetchGradingSchema: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}`);
  },

  fetchAllGradingSchemas: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings`,
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        filterProperty: payload.filterBy,
        filterValue: payload.filterValue,
        isActive: payload.isActive,
      },
    });
  },
  createGradingSchema: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings`,
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  updateGradingSchema: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  deleteGradingSchema: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}gradings/${id}`);
  },

  fetchTrainingGradings: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/training`);
  },

  updateTrainingGradings: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/training`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  fetchProfessionalEventGradings: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/professionalEvent`);
  },

  updateProfessionalEventGradings: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/professionalEvent`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  fetchAuthorshipGradings: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/authorship`);
  },

  updateAuthorshipGradings: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/authorship`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  fetchEducationalActivityGradings: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/educationalActivity`);
  },

  updateEducationalActivityGradings: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/educationalActivity`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  fetchAwardGradings: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/award`);
  },

  updateAwardGradings: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/award`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },

  fetchProfessionalTitle: (id) => {
    return Axios.get(`${SETTINGS.API_URL}gradings/${id}/professionalTitle`);
  },

  updateProfessionalTitle: (id, data) => {
    return Axios({
      url: `${SETTINGS.API_URL}gradings/${id}/professionalTitle`,
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
};
